import React from 'react';
import { COLORS } from '../../../styles/tokens';
import NewOrderIcon from './NewOrderIcon';
import IconField, { bareInputStyle } from './IconField';

// Nedtrekksliste for undervalg (kornstørrelse for pukk, kvalitet for jord, hva som skal kjøres bort).
export default function OptionSelect({ id, label, required, options, value, onChange }) {
  const text = label
    ? <>{label}{required && <span style={{ color: COLORS.dangerText }}> *</span>}</>
    : undefined;
  return (
    <IconField label={text} icon="layers" htmlFor={id}>
      <select
        id={id}
        style={{ ...bareInputStyle, appearance: 'none' }}
        value={value}
        onChange={e => onChange(e.target.value)}
      >
        <option value="">Velg …</option>
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      <NewOrderIcon name="chevronDown" size={18} />
    </IconField>
  );
}
